import classNames from 'classnames'
import React, { ReactNode, useMemo } from 'react'

import './ProcessDocumentFileUploadProgress.scss'

interface ProcessDocumentFileUploadProgressIconProps {
  completed: boolean
}

export const ProcessDocumentFileUploadProgressIcon: React.FC<ProcessDocumentFileUploadProgressIconProps> = ({ completed }) => {
  if (completed) {
    return (
      <div className='d-flex align-items-center justify-content-center rounded-circle process-document-file-upload-progress-icon-wrapper zocks-bg-color-success-background'>
        <i className='bi bi-check zocks-text-success' />
      </div>
    )
  }

  return (
    <div className='d-flex align-items-center justify-content-center process-document-file-upload-progress-icon-wrapper'>
      <div className='rounded-circle process-document-file-upload-progress-icon-content zocks-bg-color-primary' />
    </div>
  )
}

export interface ProgressItem {
  isLoading: boolean
  isSuccess: boolean
  label: ReactNode
}

interface ProcessDocumentFileUploadProgressProps {
  items: ProgressItem[]
}

export const ProcessDocumentFileUploadProgress: React.FC<ProcessDocumentFileUploadProgressProps> = ({ items }) => {
  const itemsToShow = useMemo(() => items.filter(({ isLoading, isSuccess }) => isLoading || isSuccess), [items])

  if (!itemsToShow.length) {
    return null
  }

  return (
    <div className='d-flex flex-column gap-4 p-4 zocks-bg-color-gray-100 zocks-border-0.75'>
      {itemsToShow.map(({ isLoading, isSuccess, label }, index) => (
        <div key={index} className='d-flex align-items-center process-document-file-upload-progress-item zocks-gap-1 position-relative'>
          {index > 0 ? <div className='process-document-file-upload-progress-item-separator zocks-bg-color-gray-200' /> : null}
          <ProcessDocumentFileUploadProgressIcon completed={isSuccess} />
          <span className={classNames('paragraph-medium text-truncate', { 'shimmering-loader-text': isLoading })}>{label}</span>
        </div>
      ))}
    </div>
  )
}
